import React from 'react';
import { motion } from 'framer-motion';
import { personalInfo } from '../../data/content';
import SafeIcon from '../../common/SafeIcon';

const AnimatedLogo = ({ className = "", useAvatar = false, size = "lg" }) => {
  const isSm = size === "sm";

  return (
    <motion.div 
      className={`flex flex-col items-center justify-center ${className}`}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <div className={`relative flex items-center justify-center ${isSm ? 'w-16 h-16' : 'w-32 h-32'}`}>
        {/* Outer Target Ring */}
        <motion.div 
          className={`absolute rounded-full border-brand-red/30 dark:border-brand-cyan/30 ${isSm ? 'inset-[-8px] border-[2px]' : 'inset-[-15px] border-[4px]'}`}
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        />
        {/* Middle Target Ring */}
        <motion.div 
          className={`absolute rounded-full border-brand-red/50 dark:border-brand-cyan/50 ${isSm ? 'inset-[-4px] border-[2px]' : 'inset-[-8px] border-[4px]'}`}
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
        />
        {/* Inner Bullseye with Photo */}
        <motion.div 
          className={`absolute inset-0 rounded-full bg-brand-dark flex items-center justify-center overflow-hidden z-10 shadow-2xl border-white dark:border-brand-cyan ${isSm ? 'border-2' : 'border-4'}`}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.8, ease: "backOut", delay: 0.4 }}
        >
          {useAvatar ? (
            <div className="w-full h-full bg-slate-200 dark:bg-slate-800 flex items-center justify-center">
              <SafeIcon name="User" className="w-1/2 h-1/2 text-slate-400" />
            </div>
          ) : (
            <img
              src={personalInfo.photo}
              alt={personalInfo.name}
              className="w-full h-full object-cover"
            />
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AnimatedLogo;